<template>
  <v-layout row wrap>
    <v-flex xs12>
      <ul class="navigation subnav" :class="{'alert-menu__active': alert}">
        <li>
          <eshop-link :to="{ path: '/obchody-a-provize' }">Obchody a provize</eshop-link>
        </li>
        <!-- <li>
          <eshop-link :to="{ path: '/klienti' }">Klienti</eshop-link>
        </li>
        <li>
          <eshop-link :to="{ path: '/spolupracovnici' }">Spolupracovníci</eshop-link>
        </li> -->
        <li v-if="!me.podrizeny_maklere">
          <eshop-link :to="{ path: '/pozice' }">Pozice</eshop-link>
        </li>
        <li v-if="!me.podrizeny_maklere && !me.makler">
          <eshop-link :to="{ path: '/nadrizeni-pracovnici' }">Nadřízení pracovníci</eshop-link>
        </li>
        <li>
          <eshop-link :to="{ path: '/testovaci-klient' }" target="_blank">Testovací klient</eshop-link>
        </li>
      </ul>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    data () {
      return {
        alert: true
      }
    },
    computed: {
      me: function() {
        return window.$me;
      }
    }
  }
</script>
